import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import hasFeature from 'modules/core/lib/hasFeature'

import PolicyShiftLocation from 'modules/attendance/components/SettingItemPage/TimeTracking/PolicyShiftLocation'
import ToleranceSettings from 'modules/attendance/components/TimeTrackingSettings/ToleranceSettings'
import AttendanceSettingShiftLocationForm from 'modules/attendance/lib/forms/AttendanceSettingShiftLocationForm'
import { useTimeTrackingFeatureAvailability } from 'modules/attendance/lib/useTimeTrackingFeatureAvailability'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

interface Props {
  attendanceSetting: AttendanceSetting
}

const PolicyOvertime = ({ attendanceSetting }: Props) => {
  const toleranceSettingEnabled = useTimeTrackingFeatureAvailability(
    'time_tracking_ranges_and_tolerances'
  )

  const settingForm = useLazyRef(
    () =>
      new AttendanceSettingShiftLocationForm({
        enable_clock_in_location: attendanceSetting.attributes.enable_clock_in_location,
      })
  ).current

  const shiftLocationEnabled = hasFeature('dev_time_tracking_shift_location')

  return (
    <Box>
      {toleranceSettingEnabled && <ToleranceSettings attendanceSetting={attendanceSetting} />}
      {shiftLocationEnabled && (
        <PolicyShiftLocation attendanceSetting={attendanceSetting} settingForm={settingForm} />
      )}
    </Box>
  )
}

export default observer(PolicyOvertime)
